
import statuses from "@/constatnts/statuses";

export default {
    async addBloodType({ commit }, payload) {
        try {
            let res = await addBloodType(payload)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },

    async deleteBloodType({ commit }, payload) {
        try {
            let res = await deleteBloodType(payload.bloodTypeId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getBloodTypes({ commit }) {
        try {
            let res = await getBloodTypes();
            if(res) {
                commit('SET_BLOOD_TYPES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getActiveBloodTypes({ commit }) {
        try {
            let res = await searchBloodType({status: statuses.ACTIVE});
            if(res) {
                commit('SET_BLOOD_TYPES', res.data.data)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async updateBloodType({commit},payload) {
        try {
            let res = await updateBloodType(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchBloodType({ commit }, payload) {
        try {
            let res = await searchBloodType(payload);
            if(res) {
                commit('SET_BLOOD_TYPES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getBloodType({ commit }, id) {
        try {
            let res = await getBloodType(id);
            if(res) {
                commit('SET_BLOOD_TYPE_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}